import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import global from '@/global'

Vue.prototype.GLOBAL = global
Vue.prototype.$axios = axios
axios.defaults.baseURL = Vue.prototype.GLOBAL.API_URL

axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Basic bWlqaWF5b3U6NnpXa3l3ZmtmZ1NyVmNQdQ=='
    config.headers['Http-X-Authentication-Token'] = window.localStorage.getItem('token')
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error) {
      if (error.response.data.code === 2002 || error.response.data.code === 2003) { // 返回 401 清除token信息并跳转到登录页面
        return
      }
      if (error.response.status === 500) {
        
      }
      if (error.response.status == 401) {
        
      }
    }
    return Promise.reject(error.response.data) // 返回接口返回的错误信息
  }
)



// WEBPACK FOOTER //
// ./src/axios/index.js